module.exports = "../fonts/SFUIText-Regular.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/SFUIText-Regular.otf
// module id = 569
// module chunks = 0